import Container from './check-authentication.container';

export { USER_OBTAINED_NO_SESSION, USER_OBTAINED_SESSION } from './check-authentication.constants';

export default Container;
